import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {useAuth} from "../contexts/AuthContext";

const SchoolAdminRegistration = () => {
  const {signup} = useAuth();

  const [Name, setName] = useState("");
  const [Email, setEmail] = useState("");
  const [Phone, setPhone] = useState("");
  const [Pass, setPass] = useState("");
  const [Pass2, setPass2] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (Pass !== Pass2) {
      alert("비밀번호가 일치하지 않습니다.");
      setPass("");
      setPass2("");
      return;
    }

    try {
      const result = await signup(Email, Pass, Name, Phone);
      if (!result?.user?.uid) return;

      navigate("/schoolAdminRegistrationSuccess", {
        state: {Name, Email},
      });
    } catch (error) {
      if (error.code === "auth/email-already-in-use") {
        alert("이미 가입된 이메일입니다. 로그인 페이지로 이동해주세요.");
      } else {
        alert("회원가입 중 오류가 발생했습니다: " + error.message);
      }
    }
  };

  const handleLoginClick = () => {
    navigate("/schoolLogin");
  };

  return (
    <main>
      <section className="p-0 d-flex align-items-center position-relative overflow-hidden">
        <div className="container-fluid g-0">
          <div className="row">
            {/* Left Side */}
            <div className="col-12 col-lg-6 d-md-flex align-items-center justify-content-center bg-primary bg-opacity-10 vh-lg-100">
              <div className="p-3 p-lg-5 text-center">
                <h2 className="fw-bold">Welcome to our programming language world!</h2>
                <p className="mb-0 h6 fw-light">Let&apos;s study something new today!</p>
                <img src="/assets/images/element/02.svg" className="mt-5" alt="" />
                <div className="d-sm-flex mt-5 align-items-center justify-content-center">
                  <ul className="avatar-group mb-2 mb-sm-0">
                    <li className="avatar avatar-sm"><img className="avatar-img rounded-circle" src="/assets/images/avatar/01.jpg" alt="avatar" /></li>
                    <li className="avatar avatar-sm"><img className="avatar-img rounded-circle" src="/assets/images/avatar/02.jpg" alt="avatar" /></li>
                    <li className="avatar avatar-sm"><img className="avatar-img rounded-circle" src="/assets/images/avatar/03.jpg" alt="avatar" /></li>
                    <li className="avatar avatar-sm"><img className="avatar-img rounded-circle" src="/assets/images/avatar/04.jpg" alt="avatar" /></li>
                  </ul>
                  <p className="mb-0 h6 fw-light ms-0 ms-sm-3">2k+ Students joined us, now it&apos;s your turn.</p>
                </div>
              </div>
            </div>

            {/* Right Side Form */}
            <div className="col-12 col-lg-6 m-auto vh-lg-100">
              <div className="row my-5">
                <div className="col-sm-10 col-xl-8 m-auto">
                  <img src="/assets/images/element/03.svg" className="h-40px mb-2" alt="" />
                  <h2>학교 관리자 회원 가입</h2>
                  <p className="lead mb-4">
                    학교 정보 등록과 라이선스 구매용 이메일 계정을 등록합니다.
                  </p>

                  <form onSubmit={handleSubmit}>
                    {/* 이름 */}
                    <div className="mb-4">
                      <label className="form-label">이름 *</label>
                      <div className="input-group input-group-lg">
                        <input
                          type="text"
                          className="form-control border-0 bg-light rounded"
                          placeholder="홍길동"
                          value={Name}
                          onChange={(e) => setName(e.target.value)}
                          required
                        />
                      </div>
                    </div>

                    {/* 이메일 */}
                    <div className="mb-4">
                      <label htmlFor="email" className="form-label">이메일 *</label>
                      <div className="input-group input-group-lg">
                        <span className="input-group-text bg-light border-0 text-secondary px-3">
                          <i className="bi bi-envelope-fill"></i>
                        </span>
                        <input
                          type="email"
                          className="form-control border-0 bg-light rounded-end ps-1"
                          autoComplete="off"
                          placeholder="gildong@startc.org"
                          value={Email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </div>
                    </div>

                    {/* 전화번호 */}
                    <div className="mb-4">
                      <label className="form-label">전화번호 *</label>
                      <div className="input-group input-group-lg">
                        <input
                          type="tel"
                          className="form-control border-0 bg-light"
                          placeholder="01012345678"
                          value={Phone}
                          onChange={(e) => setPhone(e.target.value)}
                          required
                        />
                      </div>
                    </div>

                    {/* 비밀번호 */}
                    <div className="mb-4">
                      <label htmlFor="password" className="form-label">비밀번호 *</label>
                      <div className="input-group input-group-lg">
                        <span className="input-group-text bg-light border-0 text-secondary px-3">
                          <i className="fas fa-lock"></i>
                        </span>
                        <input
                          type="password"
                          className="form-control border-0 bg-light rounded-end ps-1"
                          autoComplete="new-password"
                          placeholder="비밀번호 (영문 + 숫자 + 특수문자) 8자리 이상"
                          value={Pass}
                          onChange={(e) => setPass(e.target.value)}
                          required
                        />
                      </div>
                    </div>

                    {/* 비밀번호 확인 */}
                    <div className="mb-4">
                      <label htmlFor="confirmPassword" className="form-label">비밀번호 확인 *</label>
                      <div className="input-group input-group-lg">
                        <span className="input-group-text bg-light border-0 text-secondary px-3">
                          <i className="fas fa-lock"></i>
                        </span>
                        <input
                          type="password"
                          className="form-control border-0 bg-light rounded-end ps-1"
                          placeholder="위와 같은 비밀번호를 한 번 더 입력하세요!"
                          value={Pass2}
                          onChange={(e) => setPass2(e.target.value)}
                          required
                        />
                      </div>
                    </div>

                    {/* 체크박스 */}
                    <div className="mb-4 form-check">
                      <input type="checkbox" className="form-check-input" id="checkbox-1" required />
                      <label className="form-check-label" htmlFor="checkbox-1">
                        <a href="/documents/Privacy.html">개인정보처리방침</a>내용과 회원가입에 동의합니다.
                      </label>
                    </div>

                    {/* 버튼 */}
                    <div className="d-flex gap-2 justify-content-start">
                      <button className="btn btn-primary mb-0" type="submit">
                        등록
                      </button>

                      <button className="btn btn-light mb-0" onClick={handleLoginClick}>
                        <span className="">계정이 있는 경우 </span>로그인
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default SchoolAdminRegistration;
